export default __webpack_public_path__ + "static/PEPEGOD-92253e286e2007cff15cb0049cf06eb5.png";